import React, { useState, useEffect, useMemo } from 'react';
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { motion, easeOut } from "framer-motion";

import Classes from "./Hero.module.css";

import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import SparklesIcon from '../../../../../utils/Icons';
import SplitText from '../../../../../utils/ReactUI/SplitText/SplitText';

export default function Hero() {
    const { user } = useSelector((state) => state.auth);
    const navigate = useNavigate();

    const navigateToSignup = () => navigate('/signup/manufacturer');

    return (
        <>
            <section id="home" className={`${Classes.home} layoutPadding`}>
                <div className={Classes.container}>
                    {/* Left — copy */}
                    <motion.div
                        className={Classes.colLeft}
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0, transition: { duration: 0.5, ease: easeOut } }}
                    >
                        <h1 className={Classes.title} >
                            <SplitText
                                text="Partner with LightTrack"
                                className="text-2xl font-semibold text-center"
                                delay={5}
                                duration={1.5}
                                ease="elastic.out(1,0.3)"
                                splitType="chars"
                                from={{ opacity: 0, y: 40 }}
                                to={{ opacity: 1, y: 0 }}
                                threshold={0}
                                rootMargin="-100px"
                                textAlign="center"
                                // onLetterAnimationComplete={handleAnimationComplete}
                            />
                        </h1>

                        <p className={Classes.sub}>
                            Reach thousands of designers, showcase your lighting products, and gain valuable insights into buyer behavior.
                        </p>

                        <div className={Classes.ctaRow}>
                            <button className={Classes.primaryBtn} onClick={navigateToSignup} >
                                Get started for free
                            </button>
                        </div>
                    </motion.div>

                    <motion.div
                        className={Classes.colRight}
                        initial={{ opacity: 0, scale: 0.98 }}
                        animate={{ opacity: 1, scale: 1, transition: { duration: 0.5, ease: easeOut, delay: 0.1 } }}
                    >
                        <div className={Classes.heroCard}>
                            <LazyLoadImage
                                effect="blur"
                                className={Classes.heroImg}
                                src="/assets/images/manufacturer-hero.png"
                                alt="Lighting fixture drawings and samples on a desk"
                                draggable={false}
                            />
                        </div>
                    </motion.div>
                </div>
                <img
                    src="/assets/images/hero-wave.png"
                    alt=""
                    aria-hidden="true"
                    className={Classes.authBg}
                    draggable={false}
                    loading="eager"
                    decoding="async"
                    fetchPriority="high"
                />
            </section>
        </>
    );
}
